/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Button,
  Input,
  InputGroup,
  InputGroupText,
  Spinner,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faMinusCircle } from '@fortawesome/pro-duotone-svg-icons';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import EditSection from './EditSection';
import {
  loadLogos,
  loadOrganizations,
  updateOrganization,
} from '../../../actions/logos';

class AddLogo extends React.PureComponent {
  constructor(props) {
    super(props);
  
    this.state = {
      updating: false,
      counter: 0,
    };
  }
  
  componentDidMount() {
    loadLogos();
    loadOrganizations();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({ type: 'SET_EDIT_LOGO_MODE', payload: '' });
    dispatch({ type: 'CLEAR_ORG_EDIT' });
    dispatch({ type: 'SET_ORG_FILTER', payload: '' });
  }

  updateOrganizations = () => {
    const { editLogoMode, organizationsToEdit, editMultipleSelections } = this.props;
    this.setState({ updating: true, counter: 0 });

    if (editLogoMode === 'individual') {
      organizationsToEdit.forEach((o) => {
        if (o.logo_id) {
          updateOrganization(o.id, { logoID: o.logo_id === 'null' ? null : o.logo_id })
            .then(() => { this.setState(prevState => ({ ...prevState, counter: prevState.counter + 1 })) });
        }

        if (o.display_name || o.display_name == '') {
          updateOrganization(o.id, { displayName: o.display_name })
            .then(() => { this.setState(prevState => ({ ...prevState, counter: prevState.counter + 1 })) });
        }
      });
    }

    if (editLogoMode === 'multiple') {
      if (
        editMultipleSelections.logo_id
        || editMultipleSelections.display_name
      ) {
        organizationsToEdit.forEach((o) => {
          if (editMultipleSelections.logo_id) {
            updateOrganization(o.id, { logoID: editMultipleSelections.logo_id === 'null' ? null : editMultipleSelections.logo_id })
              .then(() => { this.setState(prevState => ({ ...prevState, counter: prevState.counter + 1 })) });
          }
  
          if (editMultipleSelections.display_name) {
            updateOrganization(o.id, { displayName: editMultipleSelections.display_name })
              .then(() => { this.setState(prevState => ({ ...prevState, counter: prevState.counter + 1 })) });
          }
        });
      }
    }
  }

  render() {
    const {
      editLogoMode,
      logosLoading,
      organizationsLoading,
      organizationFilter,
      organizationsToEdit,
      editMultipleSelections,
      updatingOrganization,
      dispatch,
    } = this.props;
    const { counter, updating } = this.state;

    if (counter === organizationsToEdit.length && updating) {
      this.setState({ updating: false });
      loadLogos();
      loadOrganizations();
      dispatch({ type: 'SET_EDIT_LOGO_MODE', payload: '' });
      dispatch({ type: 'CLEAR_ORG_EDIT' });
    };

    let saveButtonDisable = false;
    if (editLogoMode === 'multiple') {
      if (
        (!editMultipleSelections.logo_id && !editMultipleSelections.display_name)
        || organizationsToEdit.length === 0
      ) {
        saveButtonDisable = true;
      }
    }
    if (editLogoMode === 'individual') {
      if (organizationsToEdit.length === 0) {
        saveButtonDisable = true;
      }
    }

    return (
      <>
        <Row className="mb-4 fade-in">
          <Col className="d-flex mx-5 justify-content-between">
            <div className="d-flex align-items-baseline flex-grow-1">
              <h4 className="mb-3 me-3 text-nowrap">Carrier Logo Matching</h4>
              <Button
                outline={editLogoMode === '' || editLogoMode === 'multiple'}
                className="me-2 text-nowrap"
                onClick={() => { dispatch({ type: 'SET_EDIT_LOGO_MODE', payload: 'individual' }); }}
                disabled={editLogoMode === 'multiple' || logosLoading || organizationsLoading}
              >
                Edit Individually
              </Button>
              <Button
                outline={editLogoMode === '' || editLogoMode === 'individual'}
                className="me-3 text-nowrap"
                onClick={() => { dispatch({ type: 'SET_EDIT_LOGO_MODE', payload: 'multiple' }); }}
                disabled={editLogoMode === 'individual' || logosLoading || organizationsLoading}
              >
                Edit Multiple
              </Button>
              <InputGroup className="w-25">
                <Input
                  placeholder="Search Organizations"
                  onChange={(e) => dispatch({ type: 'SET_ORG_FILTER', payload: e.target.value })}
                  value={organizationFilter}
                  disabled={logosLoading || organizationsLoading}
                />
                <InputGroupText>
                  <Button
                    outline
                    color="danger"
                    style={{ border: '1px solid lightGrey' }}
                    onClick={() => dispatch({ type: 'SET_ORG_FILTER', payload: '' })}
                    disabled={logosLoading || organizationsLoading}
                  >
                    <FontAwesomeIcon icon={faMinusCircle} size="sm" />
                  </Button>
                </InputGroupText>
              </InputGroup>
            </div>
            {
              editLogoMode
                ? (
                  <div className="fade-in">
                    <Button
                      className="me-2"
                      outline
                      onClick={this.updateOrganizations}
                      disabled={updatingOrganization || saveButtonDisable || updating}
                    >
                      <FontAwesomeIcon icon={faSave} size="lg" className="me-2" />
                      Save
                      {updatingOrganization || updating ? <Spinner size="sm" className="ms-1" /> : null}
                    </Button>
                    <Button
                      color="danger"
                      onClick={() => {
                        dispatch({ type: 'SET_EDIT_LOGO_MODE', payload: '' });
                        dispatch({ type: 'CLEAR_ORG_EDIT' });
                      }}
                      disabled={updatingOrganization || updating}
                    >
                      <FontAwesomeIcon icon={faTimes} size="lg" className="me-2" />
                      Cancel
                    </Button>
                  </div>
                ) : null
            }
          </Col>
        </Row>
        {
          logosLoading || organizationsLoading
            ? (
              <div className="text-center mb-5">
                <Spinner color="dark" type="grow" style={{ width: '5rem', height: '5rem' }} />
                <Spinner color="dark" type="grow" style={{ width: '5rem', height: '5rem' }} />
                <Spinner color="dark" type="grow" style={{ width: '5rem', height: '5rem' }} />
              </div>
            ) : (
              <EditSection />
            )
        }
      </>
    );
  }
}

const mapStateToProps = (store) => ({
  editLogoMode: store.modals.editLogoMode,
  logosLoading: store.logos.logosLoading,
  organizationsLoading: store.logos.organizationsLoading,
  organizationFilter: store.logos.organizationFilter,
  organizationsToEdit: store.logos.organizationsToEdit,
  editMultipleSelections: store.logos.editMultipleSelections,
  updatingOrganization: store.logos.updatingOrganization
});

export default connect(mapStateToProps)(AddLogo);
